import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ReportBody } from "@/pages/app/DeliveryIntelligence";

export default function PublicReport() {
  const { token } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/public/brand-report/${token}`)
      .then((r) => setReport(r.data))
      .catch(() => setError("Report not found or link expired."));
  }, [token]);
  return (
    <div className="min-h-screen bg-background px-4 py-10" data-testid="public-report-page">
      <div className="max-w-3xl mx-auto space-y-4">
        {error && <div className="text-center text-sm text-muted-foreground border border-dashed border-border p-10" data-testid="public-report-error">{error}</div>}
        {!error && !report && <div className="text-center text-sm text-muted-foreground p-10">Loading report…</div>}
        {report && <ReportBody report={report} />}
        <p className="text-center text-[10px] text-muted-foreground">Prepared with Acquilix — Agency OS</p>
      </div>
    </div>
  );
}
